import { useSelector } from "react-redux"

// Screens that title-case the raw code render "Merit Point" for MERIT_POINT, which stopped matching
// eproc's naming. Resolve through the master so every screen shows one vocabulary in one language.
export default function useEvaluationMethodLabel(evaluationMethod) {
   const dataMasters = useSelector((state) => state.masterDataReducer.dataMasters)

   if (!evaluationMethod) return ""

   return dataMasters?.evaluationMethods?.filter((v) => v.value === evaluationMethod)[0]?.label ?? ""
}
